/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Security')
    .factory('xsrfToken', ['$cookies', '$http', function($cookies, $http) {
        var
            xsrfCookieName = $http.defaults.xsrfCookieName;
        
        return {
            headerName: $http.defaults.xsrfHeaderName,
            get: function () {
                return $cookies.get(xsrfCookieName);
            }
        }
    }]);